module.exports = __webpack_public_path__ + "fonts/IndivisibleWebBoldItalic.61aa1a04.woff2";